export default __webpack_public_path__ + "static/media/cabourg.223f6353.jpg";